import "../components/sections/sticky-menu-section/sticky-menu-section"
import "../components/main-header/main-header"
import "./tom-select/tom-select"

(async () => {
  await import("./main")

  async function loadFancybox() {
    if (document.querySelectorAll("[data-fancybox]").length) {
      await import("./fancybox/fancybox")
    }
  }
  loadFancybox()

})()

async function loadLazyload() {
  if (document.querySelectorAll("[data-src], [data-bg]").length) {
    const { lazyLoading } = await import("./lazyload/lazyload-init")
    window.lazyloading = lazyLoading // add lazyloading to global window object
  }
}
loadLazyload()

async function loadCheckAllSelect() {
  if (document.querySelectorAll(".js-check-all-wrapper").length) {
    await import("./check-all/check-all");
  }
}
loadCheckAllSelect();

async function loadFormSubmitLoad() {
  if (document.querySelectorAll("form").length) {
    await import("./form-submit-load/form-submit-load");
  }
}
loadFormSubmitLoad();

document.addEventListener('DOMContentLoaded', () => {
  const main  = document.querySelector('main');
  main.classList.remove('--loading');
})
